
import { FormDebitPayment } from '3-components/OptimizelyForm';
import { useDonationBlockProps } from '../DonationBlockProvider';
import type { FC } from 'react';
import useFormIdentity from '3-components/OptimizelyForm/hooks/useFormIdentity';

const DebitForm: FC = () => {
    const { baseURL, debitForm } = useDonationBlockProps();

    const identityToken = useFormIdentity();

    if (!baseURL) {
        console.error('Missing baseURL configuration');
        return null;
    }

    if (!debitForm?.formID) {
        console.error('Missing form configuration');
        return null;
    }

    const { formID, locale = 'en-AU' } = debitForm;

    return (
        <FormDebitPayment
            formKey={formID}
            language={locale}
            baseUrl={`${baseURL}/`}
            identityInfo={identityToken}
        />
    );
};

export default DebitForm;
